import { keepPreviousData } from "@tanstack/react-query";
import { useUsersImportRows } from "PFCore/hooks/queries/users";
import { UsersImport } from "PFCore/services/users/import";
import { UsersImportRow } from "PFTypes";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ImportDataTablePage } from "../import_modal";
import { useImportModalContext } from "../import_modal/contexts/import_modal_context";
import { useColumnsGenerator } from "./use_history_details_columns";

enum ImportRowsCounters {
  Total = "total",
  Queued = "queued",
  Processing = "processing",
  Created = "created",
  Updated = "updated",
  Invalid = "invalid"
}

const PER_PAGE = 25;

export const ImportUsersHistoryDetails = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "importProfiles" });

  const { importData } = useImportModalContext<UsersImport>();
  const [page, setPage] = useState(1);
  const [selectedCounter, setSelectedCounter] = useState<ImportRowsCounters>(ImportRowsCounters.Total);

  const generateColumns = useColumnsGenerator();

  const { isLoading, data } = useUsersImportRows(
    importData!.id,
    {
      perPage: PER_PAGE,
      page,
      state: selectedCounter !== ImportRowsCounters.Total ? selectedCounter : undefined
    },
    { placeholderData: keepPreviousData }
  );

  const counters = [
    {
      selected: ImportRowsCounters.Total === selectedCounter,
      code: ImportRowsCounters.Total,
      counter: data?.meta?.total,
      title: t("history.counters.total")
    },
    {
      selected: ImportRowsCounters.Created === selectedCounter,
      code: ImportRowsCounters.Created,
      counter: data?.meta?.created,
      title: t("history.counters.created")
    },
    {
      selected: ImportRowsCounters.Updated === selectedCounter,
      code: ImportRowsCounters.Updated,
      counter: data?.meta?.updated,
      title: t("history.counters.updated")
    },
    {
      selected: ImportRowsCounters.Queued === selectedCounter,
      code: ImportRowsCounters.Queued,
      counter: data?.meta?.queued,
      title: t("history.counters.queued")
    },
    {
      selected: ImportRowsCounters.Processing === selectedCounter,
      code: ImportRowsCounters.Processing,
      counter: data?.meta?.processing,
      title: t("history.counters.processing")
    },
    {
      selected: ImportRowsCounters.Invalid === selectedCounter,
      code: ImportRowsCounters.Invalid,
      counter: data?.meta?.invalid,
      title: t("history.counters.invalid")
    }
  ];

  return (
    <ImportDataTablePage<UsersImportRow, UsersImport>
      data={data}
      isLoading={isLoading}
      importData={importData!}
      onCurrentPageChange={setPage}
      currentPage={page}
      selectedCounter={selectedCounter}
      onSelectedCounterChange={setSelectedCounter}
      counters={counters}
      generateColumns={generateColumns}
    />
  );
};
